module.exports = __webpack_public_path__ + "img/SC.be6a6a1a.svg";